import React from "react";
import ReactEcharts from "echarts-for-react";
import * as _ from "lodash";

const UnitsLineBar = ({ data, chartRef, label, xKey = 'number', yKey }) => {
  const xValues = _.map(data, xKey);
  const yValues = _.map(data, yKey);
  const maxYvalue = _.max(yValues);

  const chartData = {
    label: {
      normal: {
        show: true,
        position: "top",
      },
    },
    color: ["#fd625e"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    xAxis: {
      type: "category",
      data: xValues,
      name: "Unidades",
      nameLocation: "center",
      nameTextStyle: {
        align: "center",
        verticalAlign: "top",
        /**
         * the top padding will shift the name down so that it does not overlap with the axis-labels
         * t-l-b-r
         */
        padding: [30, 0, 0, 0],
        //backgroundColor: "yellow",
      },
      // the default nameGap=15 would move the text to the right
      nameGap: 0,
      label: {
        normal: {
          show: true,
          position: "top",
        },
      },
      interval: 0,
    },
    yAxis: {
      type: "value",
      name: label,
      min: 0,
      max: maxYvalue,
      nameGap: 40,
    },
    series: [
      {
        name: label,
        data: yValues,
        type: "bar",
        label: {
          normal: {
            show: true,
            position: "top",
            rotate: 90,
            fontSize: 9,
            verticalAlign: "middle",
            padding: [0, 0, 0, 10],
            //backgroundColor: "red",
            formatter: (params) => {
              return `  ${params.value ? params.value : ""}`;
            },
          },
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <div>
        <ReactEcharts
          ref={chartRef}
          style={{ height: "350px" }}
          option={chartData}
        />
      </div>
    </React.Fragment>
  );
};

export default UnitsLineBar;
